"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _form = require("@jsluna/form");

var _card = require("@jsluna/card");

var _utils = require("../utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var PreviewChecklist = function PreviewChecklist(_ref) {
  var title = _ref.title,
      items = _ref.items;
  var sortedChecklistItems = (items || []).slice().sort(function (item1, item2) {
    return item1.id - item2.id;
  });
  return /*#__PURE__*/_react.default.createElement(_card.Card, {
    style: {
      padding: 0
    }
  }, sortedChecklistItems.length > 0 && title && /*#__PURE__*/_react.default.createElement("h4", null, title), sortedChecklistItems.map(function (_ref2) {
    var id = _ref2.id,
        text = _ref2.text;
    return /*#__PURE__*/_react.default.createElement(_form.Checkbox, {
      key: id,
      name: "checklist-item-" + id,
      label: (0, _utils.renderTextWithLinks)(text),
      className: "ln-u-margin-ends checklist-item-checkbox",
      disabled: true
    });
  }));
};

PreviewChecklist.propTypes = {
  checklistItems: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string.isRequired,
    text: _propTypes.default.string.isRequired,
    position: _propTypes.default.number.isRequired
  })).isRequired,
  title: _propTypes.default.string
};
PreviewChecklist.defaultProps = {
  checklistItems: [],
  title: null
};
var _default = PreviewChecklist;
exports.default = _default;